import { apply, put, takeLatest, fetch } from '@ers/helpers/redux/sagaEffects';
import ApiFactory from '@ers/api/ApiFactory';
import AppApi from '@ers/root/App.api';
import { ActionTypes,
    deleteJobOfferLinkCompleted,
    fetchJobOfferLinkCompleted,
    fetchJobOfferLinkFileCompleted } from './offer.actions';



function* fetchJobOfferLink(api, action) {
    const { applicationId } = action.payload;
    const response = yield fetch(api, api.getJobOfferLink, [applicationId]);
    if (!response.error) {
        yield put(fetchJobOfferLinkCompleted(
            applicationId,
            response.data.status === 404
                ? null
                : response.data
        ));
    }
}
function* fetchJobOfferLinkFile(api, action) {
    const { applicationId, fileId } = action.payload;
    const response = yield fetch(api, api.fetchFile, [applicationId, fileId]);
    if (!response.error) {
        const url = window.URL.createObjectURL(response.data.blob);
        yield put(fetchJobOfferLinkFileCompleted(applicationId, url));
    }
}
function* deleteJobOfferLink(api, action) {
    const { applicationId } = action.payload;
    const response = yield fetch(api, api.deleteJobOfferLink, [applicationId]);
    if (!response.error) {
        yield put(deleteJobOfferLinkCompleted(applicationId));
    }
}



export default function* formSaga() {
    const apiFactory = new ApiFactory();
    const api = yield apply(apiFactory, apiFactory.create);
    const appApi = new AppApi(api);
    yield takeLatest(ActionTypes.fetchJobOfferLink, fetchJobOfferLink, appApi);
    yield takeLatest(ActionTypes.deleteJobOfferLink, deleteJobOfferLink, appApi);
    yield takeLatest(ActionTypes.fetchJobOfferLinkFile, fetchJobOfferLinkFile, appApi);
}
